<ng-container *ngIf="names && url">
  <a class="header-location-link" [routerLink]="url | currentLangLink">
    {{ (names | fieldTranslation)?.name }}
  </a>
</ng-container>
